import { createAsyncThunk } from '@reduxjs/toolkit';

import { ThunkConfig } from 'app/providers/StoreProvider';
import { ExtendedAxiosRequestConfig } from 'shared/api/types';

import { CatalogItem } from '../../types/CatalogItemSchema';

export interface FetchCatalogItemByIdRequestData {
    catalogId: string;
    itemId: string;
    abortController?: AbortController;
}

export const fetchCatalogItemById = createAsyncThunk<
    CatalogItem,
    FetchCatalogItemByIdRequestData,
    ThunkConfig<string>
>(
    'catalogItem/fetchCatalogItemById',
    async ({ catalogId, itemId, abortController }, thunkApi) => {
        const { extra, rejectWithValue } = thunkApi;

        try {
            const config: ExtendedAxiosRequestConfig = {
                signal: abortController?.signal,
                keysToNotConvert: ['specifications'],
            };

            const response = await extra.api.get<CatalogItem>(
                `/v1/catalogs/${catalogId}/items/${itemId}`,
                config,
            );

            return response.data;
        } catch (e) {
            return rejectWithValue('error');
        }
    },
);
